<div [formGroup]="form" class="is-flex">
  <span class="has-text-weight-bold mr-2" [translate]="label()"></span>
  <fino-switch
    formControlName="isProductActive"
    [hideLabel]="true"
  ></fino-switch>
</div>
